import papa from 'papaparse';

/* File Contents */
export const LOADING_BEGIN = "LOADING_BEGIN";
export const LOADING_END = "LOADING_END";
export const LOAD_FILE_SUCCESS = "LOAD_FILE_SUCCESS";
export const LOAD_FILE_ERROR = "LOAD_FILE_ERROR";
export const SET_FILENAME = "SET_FILENAME";
export const FILE_BLOB = "FILE_BLOB";
export const FILE_HEADERS_EXIST = "FILE_HEADERS_EXIST";
export const FILE_HEADERS = "FILE_HEADERS";
export const FILE_ROWS = "FILE_ROWS";
export const SELECTED_COLUMNS = "SELECTED_COLUMNS";
export const FORMULA_UPDATE = "FORMULA_UPDATE";
export const AXIS_LABEL = "AXIS_LABEL";

export function setFilename(fileId, filename) {
	return {
		type: SET_FILENAME,
		fileId,
		filename: filename,
		isLoaded: false,
	};
}

export function getHeaders(data) {
	return data.slice(0,1)[0];
}

export function getDataWithoutHeaders(data) {
	return data.slice(1);
}

export function loadFile(fileId) {
	return (dispatch, getState) => {
		dispatch(startLoading(fileId));
		let state = getState();
		let fileblob = state.fileContents[fileId].fileBlob;
		
		if (fileblob != null) {
			let file = new FileReader();

			file.onload = function(e) {
				let result = papa.parse(this.result);
				dispatch(loadFileSuccess(fileId, result.data));
				dispatch(setHeadersAndRows(fileId));
			};
			
			let loadError = function(e) {
				dispatch(loadFileError(fileId));
				dispatch(endLoading(fileId));
			};

			file.onerror = loadError;
			file.onabort = loadError;
			file.readAsText(fileblob);
		} else {
			dispatch(loadFileError(fileId));
		}
	};
}

export function storeBlob(fileId, blob) {
	return {
		type: FILE_BLOB,
		fileId,
		blob: blob,
	};
}

export function setHeadersAndRows(fileId) {
	return (dispatch, getState) => {
		dispatch(startLoading(fileId)); 
		let state = getState();
		let fileObject = state.fileContents[fileId];

		dispatch(fileContainsHeaders(fileId, fileObject.headersExist));
		
		let data = fileObject.fileContent;
		let headers = [], rows = [];

		if (data.length > 0) {
			if (fileObject.headersExist) {
				headers = getHeaders(data);
				data = getDataWithoutHeaders(data);
			} else {
				headers = Array(data[0].length).fill().map((x, i) => i);
			}
		}
		
		headers = headers.map(v => { return { Header: v, accessor: v.toString() }; });

		rows = data.map(d => {
			let values = {};
			d.map((v, i) => { values[headers[i].accessor] = v; return null; });
			return values;
		});

		dispatch(updateFileHeaders(fileId, headers));
		dispatch(updateFileRows(fileId, rows));
		dispatch(endLoading(fileId));
	};
}

export function updateSelectedHeaders(fileId, value) {
	return {
		type: SELECTED_COLUMNS,
		fileId,
		value
	};
}

export function fileContainsHeaders(fileId, exist) {
	return {
		type: FILE_HEADERS_EXIST,
		fileId,
		headersExist: exist,
	};
}

export function updateFileHeaders(fileId, headers) {
	return {
		type: FILE_HEADERS,
		fileId,
		headers,
	}
}

export function updateFileRows(fileId, rows) {
	return {
		type: FILE_ROWS,
		fileId,
		rows,
	}
}

export function loadFileSuccess(fileId, response, headers) {
	return {
		type: LOAD_FILE_SUCCESS,
		fileId,
		response,
		headers
	};
}

export function loadFileError(fileId, error) {
	return {
		type: LOAD_FILE_ERROR,
		fileId,
		error,
	};
}

export function startLoading(fileId) {
	return {
		type: LOADING_BEGIN,
		fileId,
	}
}

export function endLoading(fileId) {
	return {
		type: LOADING_END,
		fileId,
	}
}

export function setFormula(fileId, v) {
	return {
		type: FORMULA_UPDATE,
		fileId,
		formula: v,
	};
}

export function setAxisLabel(fileId, v) {
	return {
		type: AXIS_LABEL,
		fileId,
		label: v,
	};
}


// WEBPACK FOOTER //
// ./src/redux/file-actions.js